var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-wrapper',[_c('v-container',{attrs:{"fluid":""}},[_c('general-information',{on:{"save":_vm.save}}),_c('settings'),_c('platforms')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }